import {
    CREATE_MANUAL_BOOKING_START,
    CREATE_MANUAL_BOOKING_SUCCESS,
    CREATE_MANUAL_BOOKING_ERROR,
    UPDATE_SCHEDULE_BOOKING_START,
    UPDATE_SCHEDULE_BOOKING_SUCCESS,
    UPDATE_SCHEDULE_BOOKING_ERROR,
    GET_PREFERRED_PROVIDER_START,
    GET_PREFERRED_PROVIDER_SUCCESS,
    GET_PREFERRED_PROVIDER_ERROR,
    CREATE_BOOKING_ERROR
} from '../constants';

export default function booking(state = {}, action) {
    switch (action.type) {

        case CREATE_MANUAL_BOOKING_START:
            return {
                ...state,
                bookingLoading: action?.payload?.loading
            };


        case CREATE_MANUAL_BOOKING_SUCCESS:
            return {
                ...state,
                bookingLoading: action?.payload?.loading
            };


        case CREATE_MANUAL_BOOKING_ERROR:
            return {
                ...state,
                bookingLoading: action?.payload?.loading
            };

        case UPDATE_SCHEDULE_BOOKING_START:
            return {
                ...state,
                scheduledLoading: action?.payload?.loading
            };


        case UPDATE_SCHEDULE_BOOKING_SUCCESS:
            return {
                ...state,
                scheduledLoading: action?.payload?.loading
            };


        case UPDATE_SCHEDULE_BOOKING_ERROR:
            return {
                ...state,
                scheduledLoading: action?.payload?.loading
            };


        case GET_PREFERRED_PROVIDER_START:
            return {
                ...state,
                preferredProviderLoading: action?.payload?.loading,
                preferredProviders: action?.payload?.preferredProviders
            };


        case GET_PREFERRED_PROVIDER_SUCCESS:
            return {
                ...state,
                preferredProviderLoading: action?.payload?.loading,
                preferredProviders: action?.payload?.preferredProviders
            };


        case GET_PREFERRED_PROVIDER_ERROR:
            return {
                ...state,
                preferredProviderLoading: action?.payload?.loading,
                preferredProviders: action?.payload?.preferredProviders
            };
            case CREATE_BOOKING_ERROR:
            return {
                ...state,
                data: action.payload,
            };

        default:
            return {
                ...state,
            };
    }
}
